import React from 'react';
import creditsUrl from './urls';
import AuthenticatedLayoutRoute from '../../layout/AuthenticatedLayoutRoute';

import RoleErrorComponent from '../../components/Error/RoleErrorComponent';

const Credits = React.lazy(() => import(/* webpackChunkName: "Credits" */ './Credits'));
const allowedRoles = ['TEACHER', 'STUDENT', 'SCHOOL_ADMIN', 'DISTRICT_OWNER'];

const routes = [
    <AuthenticatedLayoutRoute
        exact
        key={Credits}
        path={creditsUrl}
        RoleErrorComponent={RoleErrorComponent}
        roles={allowedRoles}
        withFooter
    >
        <Credits />
    </AuthenticatedLayoutRoute>,
];

export default routes;
